import { lazy } from 'react';

import type { Route, Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';

const GraphExplorerHome = lazy(() => import('../../pages/graph-explorer/home'));

const ROUTE_PREFIX = '/graph-explorer' as const;

const graphExplorerRoutesObject: Record<string, Route> = {
	home: {
		name: 'home',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(GraphExplorerHome),
	},
};

export const graphExplorerRoutes: Routes = Object.values(graphExplorerRoutesObject);
